<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px">
    <el-form-item label="openid" prop="openid">
      <el-input v-model="dataForm.openid" placeholder="openid"></el-input>
    </el-form-item>
    <el-form-item label="名字" prop="name">
      <el-input v-model="dataForm.name" placeholder="名字"></el-input>
    </el-form-item>
    <el-form-item label="头像" prop="headurl">
      <el-input v-model="dataForm.headurl" placeholder="头像"></el-input>
    </el-form-item>
    <el-form-item label="图片1" prop="file1">
      <el-input v-model="dataForm.file1" placeholder="图片1"></el-input>
    </el-form-item>
    <el-form-item label="图片2" prop="file2">
      <el-input v-model="dataForm.file2" placeholder="图片2"></el-input>
    </el-form-item>
    <el-form-item label="图片3" prop="file3">
      <el-input v-model="dataForm.file3" placeholder="图片3"></el-input>
    </el-form-item>
    <el-form-item label="图片4" prop="file4">
      <el-input v-model="dataForm.file4" placeholder="图片4"></el-input>
    </el-form-item>
    <el-form-item label="图片5" prop="file5">
      <el-input v-model="dataForm.file5" placeholder="图片5"></el-input>
    </el-form-item>
    <el-form-item label="图片6" prop="file6">
      <el-input v-model="dataForm.file6" placeholder="图片6"></el-input>
    </el-form-item>
    <el-form-item label="创建时间" prop="createtime">
      <el-input v-model="dataForm.createtime" placeholder="创建时间"></el-input>
    </el-form-item>
    <el-form-item label="点赞数量" prop="dianzancount">
      <el-input v-model="dataForm.dianzancount" placeholder="点赞数量"></el-input>
    </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        dataForm: {
          id: 0,
          openid: '',
          name: '',
          headurl: '',
          file1: '',
          file2: '',
          file3: '',
          file4: '',
          file5: '',
          file6: '',
          createtime: '',
          dianzancount: ''
        },
        dataRule: {
          openid: [
            { required: true, message: 'openid不能为空', trigger: 'blur' }
          ],
          name: [
            { required: true, message: '名字不能为空', trigger: 'blur' }
          ],
          headurl: [
            { required: true, message: '头像不能为空', trigger: 'blur' }
          ],
          file1: [
            { required: true, message: '图片1不能为空', trigger: 'blur' }
          ],
          file2: [
            { required: true, message: '图片2不能为空', trigger: 'blur' }
          ],
          file3: [
            { required: true, message: '图片3不能为空', trigger: 'blur' }
          ],
          file4: [
            { required: true, message: '图片4不能为空', trigger: 'blur' }
          ],
          file5: [
            { required: true, message: '图片5不能为空', trigger: 'blur' }
          ],
          file6: [
            { required: true, message: '图片6不能为空', trigger: 'blur' }
          ],
          createtime: [
            { required: true, message: '创建时间不能为空', trigger: 'blur' }
          ],
          dianzancount: [
            { required: true, message: '点赞数量不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm.id = id || 0
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            this.$http({
              url: `/jxjg/jgquanzi/info/${this.dataForm.id}`,
              method: 'get',
              params: this.$http.adornParams()
            }).then((data) => {
              if (data && data.code === 0) {
                this.dataForm.openid = data.jgquanzi.openid
                this.dataForm.name = data.jgquanzi.name
                this.dataForm.headurl = data.jgquanzi.headurl
                this.dataForm.file1 = data.jgquanzi.file1
                this.dataForm.file2 = data.jgquanzi.file2
                this.dataForm.file3 = data.jgquanzi.file3
                this.dataForm.file4 = data.jgquanzi.file4
                this.dataForm.file5 = data.jgquanzi.file5
                this.dataForm.file6 = data.jgquanzi.file6
                this.dataForm.createtime = data.jgquanzi.createtime
                this.dataForm.dianzancount = data.jgquanzi.dianzancount
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: `/jxjg/jgquanzi/${!this.dataForm.id ? 'save' : 'update'}`,
              method: 'post',
              params: {
                'id': this.dataForm.id || undefined,
                'openid': this.dataForm.openid,
                'name': this.dataForm.name,
                'headurl': this.dataForm.headurl,
                'file1': this.dataForm.file1,
                'file2': this.dataForm.file2,
                'file3': this.dataForm.file3,
                'file4': this.dataForm.file4,
                'file5': this.dataForm.file5,
                'file6': this.dataForm.file6,
                'createtime': this.dataForm.createtime,
                'dianzancount': this.dataForm.dianzancount
              }
            }).then((data) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/jgquanzi-add-or-update.vue